import React from 'react';
import Layout from '../layouts/claire';
import { Link } from 'react-router';
import { Animated } from 'react-animated-css';
import config from '../../config';
import Menu from '../partials/menu';
import TopRightMenu from '../partials/top_right_menu';
import BlackOverlay from '../partials/black_overlay';
import LineLoader from '../partials/line_loader';
import _ from 'lodash';

class Guests extends React.Component {
    state = {
        menu_toggled: false,
        toggle: 1,
        rooms_selected: [],
        status: config.room_status,
        sort: 'LastName',
        hotel_name: localStorage.getItem('lb.ip') ? JSON.parse(localStorage.getItem('lb.ip')).Name : null,
        filters: { text: '', IdCountry: null, IdNationality: null, IdCivil: null },
        search_mode: false,
    }
    // Lifecycle
    componentWillMount() {
        const { id, letter } = this.props.params;
        if (id) {
            this.props.form_actions && this.props.form_actions.fetch_countries();
            this.props.form_actions && this.props.form_actions.fetch_nationalities();
            this.setState({ letter }, () => {
                this.props.properties_actions && this.props.properties_actions.fetch_guests(id, letter || 'A');
            });
        }
    }
    componentWillReceiveProps = nextProps => {
        const { guests, params } = nextProps, { letter = 'A' } = params, { id } = this.props.params;
        if (letter !== this.state.letter && !this.state.search_mode) {
            this.setState({ letter }, () => {
                this.props.properties_actions && this.props.properties_actions.fetch_guests(id, letter);
            });
        }
        else
            this.setState({ guests });
    }
    //

    onToggle = (IdStaff) => {
        const { guests } = this.state;
        let index = _.findIndex(guests, r => r.IdStaff === IdStaff);
        if (index === -1) return;
        guests[index].IsActive = !guests[index].IsActive;
        this.props.guests_actions && this.props.guests_actions.toggle(IdStaff, guests[index].IsActive);
        this.setState({ guests });
    }
    onSort = (s) => {
        const { sort } = this.state;
        if (s === sort) this.setState({ up: !this.state.up });
        else this.setState({ up: false, sort: s });
    }
    doDelete = () => {
        const { id } = this.props.params;
        this.props.guests_actions && this.props.guests_actions.archive(this.state.delete_id, id);
        this.setState({ delete_id: null });
    }
    onDownloadCSV = () => {
        const { id, letter } = this.props.params;
        const { guests } = this.state;
        if (!guests || guests.length === 0) return;

        const isBlacklist = letter === 'blst';
        const headers = isBlacklist
            ? ['FirstName', 'LastName', 'Email', 'Phone', 'Cellphone', 'Profession', 'BlacklistMotivo']
            : ['FirstName', 'LastName', 'Email', 'Phone', 'Cellphone', 'Profession'];
        const csvContent = [
            headers.join(','),
            ...guests.map(guest =>
                headers.map(header => `"${(guest[header] || '').toString().replace(/"/g, '""')}"` ).join(',')
            )
        ].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = isBlacklist ? `Blacklist - Huespedes.csv` : `Guests - ${(letter || 'A')}.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
    }

    hasActiveFilters = () => {
        const { filters } = this.state;
        return filters.text || filters.IdCountry || filters.IdNationality || filters.IdCivil;
    }

    onFilterChange = (key, value) => {
        const { filters } = this.state;
        filters[key] = value || null;
        const active = !!(filters.text || filters.IdCountry || filters.IdNationality || filters.IdCivil);
        this.setState({ filters, search_mode: active }, () => {
            if (active) {
                this.props.properties_actions && this.props.properties_actions.search_guests(this.props.params.id, filters);
            } else {
                // No filters — reload current letter
                const letter = this.props.params.letter || 'A';
                this.props.properties_actions && this.props.properties_actions.fetch_guests(this.props.params.id, letter);
            }
        });
    }

    onClearFilters = () => {
        const { id, letter = 'A' } = this.props.params;
        this.setState({ filters: { text: '', IdCountry: null, IdNationality: null, IdCivil: null }, search_mode: false }, () => {
            this.props.properties_actions && this.props.properties_actions.fetch_guests(id, letter);
        });
    }

    renderHeader = () => {
        return <div className="d-flex">
            <div className="w-100 d-flex ">
                <i className="icon-lb_huespedes blue font-40 align-self-center" />
                <div className="align-self-center d-flex flex-column">
                    <span className="white ms-3 font-20 line1 poppins">Huespedes</span>
                    <Link to="/properties" className="white ms-3 font-10 poppins underlined">{this.state.hotel_name}</Link>
                </div>
            </div>
            <div className="w-100 d-flex align-self-center">
                <TopRightMenu {...this.props} />
            </div>
        </div>
    }

    renderFilters = () => {
        const { filters, search_mode, guests } = this.state;
        const { countries = [], nationalities = [] } = this.props;
        const active = this.hasActiveFilters();

        return (
            <div className="mt-3">
                {/* Search + filter bar */}
                <div className="d-flex flex-wrap" style={{ gap: 8 }}>

                    {/* Text search */}
                    <div className="bg-gray-2 black-input d-flex" style={{ flex: '1 1 220px', minWidth: 200 }}>
                        <i className="fas fa-search font-14 white align-self-center ps-3" />
                        <input
                            className="w-100 p-2 white font-12"
                            type="text"
                            value={filters.text || ''}
                            placeholder="Nombre, apellido, cédula, email..."
                            onChange={e => this.onFilterChange('text', e.target.value)}
                        />
                        {filters.text && <i className="fas fa-times gray font-12 align-self-center pe-2 pointer" onClick={() => this.onFilterChange('text', '')} />}
                    </div>

                    {/* Country */}
                    <div className="bg-gray-2 d-flex" style={{ flex: '1 1 170px', minWidth: 160 }}>
                        <i className="fas fa-globe font-12 white align-self-center ps-3" />
                        <select
                            className="w-100 p-2 white font-12"
                            style={{ background: 'transparent', border: 'none', outline: 'none', color: filters.IdCountry ? '#fff' : '#888' }}
                            value={filters.IdCountry || ''}
                            onChange={e => this.onFilterChange('IdCountry', e.target.value ? parseInt(e.target.value) : null)}>
                            <option value="">País</option>
                            {_.chain(countries).sortBy('name').value().map(c => (
                                <option key={c.id} value={c.id} style={{ background: '#222', color: '#fff' }}>{c.name}</option>
                            ))}
                        </select>
                    </div>

                    {/* Nationality */}
                    <div className="bg-gray-2 d-flex" style={{ flex: '1 1 170px', minWidth: 160 }}>
                        <i className="fas fa-passport font-12 white align-self-center ps-3" />
                        <select
                            className="w-100 p-2 white font-12"
                            style={{ background: 'transparent', border: 'none', outline: 'none', color: filters.IdNationality ? '#fff' : '#888' }}
                            value={filters.IdNationality || ''}
                            onChange={e => this.onFilterChange('IdNationality', e.target.value ? parseInt(e.target.value) : null)}>
                            <option value="">Nacionalidad</option>
                            {_.chain(nationalities).sortBy('name').value().map(n => (
                                <option key={n.id} value={n.id} style={{ background: '#222', color: '#fff' }}>{n.name}</option>
                            ))}
                        </select>
                    </div>

                    {/* Civil status */}
                    <div className="bg-gray-2 d-flex" style={{ flex: '1 1 150px', minWidth: 140 }}>
                        <i className="fas fa-heart font-12 white align-self-center ps-3" />
                        <select
                            className="w-100 p-2 white font-12"
                            style={{ background: 'transparent', border: 'none', outline: 'none', color: filters.IdCivil ? '#fff' : '#888' }}
                            value={filters.IdCivil || ''}
                            onChange={e => this.onFilterChange('IdCivil', e.target.value ? parseInt(e.target.value) : null)}>
                            <option value="">Estado civil</option>
                            {config.civil.map(c => (
                                <option key={c.id} value={c.id} style={{ background: '#222', color: '#fff' }}>{c.value}</option>
                            ))}
                        </select>
                    </div>

                    {/* Clear button — only when filters are active */}
                    {active && (
                        <button onClick={this.onClearFilters} className="btn btn-link d-flex align-self-center" style={{ color: '#888', fontSize: 12 }}>
                            <i className="fas fa-times-circle me-1 align-self-center" />
                            <span className="align-self-center poppins">Limpiar</span>
                        </button>
                    )}
                </div>

                {/* Search mode indicator */}
                {search_mode && guests && (
                    <div className="mt-2">
                        <span className="poppins font-10" style={{ color: '#555' }}>
                            <i className="fas fa-filter me-1" style={{ color: '#008db5' }} />
                            {guests.length} resultado{guests.length !== 1 ? 's' : ''} — búsqueda global
                        </span>
                    </div>
                )}
            </div>
        );
    }
    renderTH = () => {
        const { sort } = this.state;
        return <thead>
            <tr>
                <th className="bg-gray-2 white">Nombre <i className={`icon-lb_sort ${sort === 'FirstName' ? 'blue' : 'gray'}`}
                    onClick={() => this.onSort('FirstName')} /></th>
                <th className="bg-gray-2 white">Contacto</th>
                <th className="bg-gray-2 black"></th>
                <th className="bg-gray-2 white text-right">Accion</th>
            </tr>
        </thead>
    }
    renderTable = () => {
        const { guests, sort, up } = this.state;
        let filtered_staff = guests || [];
        return <div className="mt-4 d-flex">
            <Animated animationIn='fadeInRight' isVisible={guests ? true : false} animationInDuration={300}
                animateOnMount={false} className="w-100 bg-gray-2 px-3 py-2 rounded d-flex">
                <table className="w-100 table m-0 poppins bg-gray-2 white">
                    {this.renderTH()}
                    {guests && filtered_staff.length > 0 && <tbody>
                        {_.chain(filtered_staff)
                            .sortBy(sort)
                            .tap(arr => {
                                if (up) arr.reverse();
                            })
                            .value().map((staff, index) => <tr key={staff.IdGuest}>
                                <td className="bg-gray-2 white">
                                    <div className="d-flex">
                                        <div className="cover" style={{ width: 30, height: 30, borderRadius: 15, border: `1px solid #1771FF`, background: `url(${staff.LogoUrl}) no-repeat center center` }}></div>
                                        <div className="d-flex flex-column">
                                            <span className="ms-2 align-self-start white font-12">{`${staff.LastName} ${staff.FirstName}`}</span>
                                            <span className="ms-2 align-self-start gray font-10">{`${_.compact([staff.Profession, staff.Company]).join(' | ')}`}</span>
                                        </div>
                                    </div>
                                </td>
                                <td className="bg-gray-2 font-10 white">
                                    <span className="blue">{staff.Email}</span><br />{`${staff.PhoneCountryCode} ${staff.Phone} | ${staff.CellPhoneCountryCode} ${staff.Cellphone}`}
                                </td>
                                <td className="bg-gray-2 font-10 white">
                                    {staff.IsBlacklisted == 1 && <span className={`w3-tag white rounded`}>Blacklisted</span>}

                                </td>
                                <td className="bg-gray-2 white">
                                    <div className="d-flex justify-content-end">
                                        <Link to={`/guest/${staff.IdGuest}`}><i className="fas fa-edit ms-3 font-16 pointer blue" /></Link>
                                        {/*<i className="fas fa-trash ms-3 font-16 pointer gray" onClick={() => this.setState({ delete_id: staff.IdGuest })} />*/}
                                    </div>
                                </td>
                            </tr>)}
                    </tbody>}
                    {guests && filtered_staff.length === 0 && <tbody>
                        <tr>
                            <td colSpan={6} className="bg-gray-2 gray-light">
                                <div className="d-flex justify-content-center" style={{ height: 200 }}>
                                    <h3 className="align-self-center gray text-center poppins">Por lo visto no tienes huéspedes en esta propiedad<br />{this.state.search ? ` bajo estos parámetros de búsqueda` : ''}.</h3>
                                </div>
                            </td>
                        </tr>
                    </tbody>}
                </table>
            </Animated>
        </div>
    }
    renderCommon = () => {
        const { letter = 'A' } = this.props.params;
        const { guests, search_mode } = this.state;
        return (
            <div className="">
                {this.renderHeader()}
                {this.renderFilters()}
                <div className={`w-100 d-flex justify-content-center mt-3 white ${search_mode ? 'opacity-25' : ''}`}
                    style={{ opacity: search_mode ? 0.3 : 1, pointerEvents: search_mode ? 'none' : 'auto' }}>
                    <Link className={`btn btn-link  ${letter === 'A' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/A`}>A</Link>
                    <Link className={`btn btn-link  ${letter === 'B' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/B`}>B</Link>
                    <Link className={`btn btn-link  ${letter === 'C' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/C`}>C</Link>
                    <Link className={`btn btn-link  ${letter === 'D' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/D`}>D</Link>
                    <Link className={`btn btn-link  ${letter === 'E' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/E`}>E</Link>
                    <Link className={`btn btn-link  ${letter === 'F' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/F`}>F</Link>
                    <Link className={`btn btn-link  ${letter === 'G' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/G`}>G</Link>
                    <Link className={`btn btn-link  ${letter === 'H' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/H`}>H</Link>
                    <Link className={`btn btn-link  ${letter === 'I' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/I`}>I</Link>
                    <Link className={`btn btn-link  ${letter === 'J' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/J`}>J</Link>
                    <Link className={`btn btn-link  ${letter === 'K' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/K`}>K</Link>
                    <Link className={`btn btn-link  ${letter === 'L' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/L`}>L</Link>
                    <Link className={`btn btn-link  ${letter === 'M' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/M`}>M</Link>
                    <Link className={`btn btn-link  ${letter === 'N' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/N`}>N</Link>
                    <Link className={`btn btn-link  ${letter === 'O' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/O`}>O</Link>
                    <Link className={`btn btn-link  ${letter === 'P' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/P`}>P</Link>
                    <Link className={`btn btn-link  ${letter === 'Q' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/Q`}>Q</Link>
                    <Link className={`btn btn-link  ${letter === 'R' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/R`}>R</Link>
                    <Link className={`btn btn-link  ${letter === 'S' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/S`}>S</Link>
                    <Link className={`btn btn-link  ${letter === 'T' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/T`}>T</Link>
                    <Link className={`btn btn-link  ${letter === 'U' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/U`}>U</Link>
                    <Link className={`btn btn-link  ${letter === 'V' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/V`}>V</Link>
                    <Link className={`btn btn-link  ${letter === 'W' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/W`}>W</Link>
                    <Link className={`btn btn-link  ${letter === 'X' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/X`}>X</Link>
                    <Link className={`btn btn-link  ${letter === 'Y' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/Y`}>Y</Link>
                    <Link className={`btn btn-link  ${letter === 'Z' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/Z`}>Z</Link>
                    <Link className={`btn btn-link  ${letter === 'blst' ? 'blue' : 'gray'}`} to={`/guests/${this.props.params.id}/blst`}>(Blacklist)</Link>
                    <button onClick={this.onDownloadCSV} className={`btn btn-link ${guests?.length > 0 ? 'blue' : 'gray'}`}><i className="fas fa-download" /> Descargar</button>
                </div>
                {this.renderTable()}
                <div style={{ height: 200 }} />
            </div>
        )
    }
    render() {
        const form = this.props.form_actions;
        const { rooms_selected, status } = this.state;
        return (
            <Layout router={this.props.router} nbs="home" title="legendbeds" form={this.props.form} form_actions={this.props.form_actions}>
                <section>

                    {this.state.microTransac && <LineLoader />}

                    {/* DESKTOP */}
                    <div className="w3-container w3-hide-small " style={{ marginLeft: 100 }}>
                        <div style={{ height: 50 }} />
                        {this.renderCommon()}
                    </div>
                    {/* MOBILE */}
                    {/*<div className="w3-container w3-hide-medium w3-hide-large">
                        <div style={{ height: 65 }} />
                        {this.renderCommon()}
        </div>*/}

                    <Menu {...this.state} {...this.props} />

                    {/* Delete Confirm */}
                    <Animated animateOnMount={false} animationIn='fadeIn' animationInDuration={200} animationOutDuration={200} animationOut='fadeOut' isVisible={this.state.delete_id ? true : false}>
                        <BlackOverlay />
                        <div className="d-flex justify-content-center" style={{ position: 'fixed', top: 0, bottom: 0, left: 100, right: 0, zIndex: 1 }}>
                            <div className="black-input bg-gray-2 p-4 align-self-center">
                                <h3 className="white poppins text-center">Confirmar operación</h3>
                                <h6 className="blue text-center poppins">Eliminar huesped</h6>
                                <hr className="w-50 mx-auto" />
                                <h6 className="white text-center poppins">¿Está seguro de eliminar este empleado?</h6>
                                <div className="d-flex justify-content-center mt-4">
                                    <button onClick={() => this.setState({ delete_id: false })} type="button" className="btn btn-lg btn-gray-2 white ms-3 align-self-center" >
                                        <i className="fas fa-times white font-12" />
                                    </button>
                                    <button onClick={this.doDelete} type="button" className="btn btn-lg btn-blue white ms-3 align-self-center" >
                                        <i className="fas fa-check white font-12" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Animated>
                </section>
            </Layout>
        )
    }
}

export default Guests;
